export enum TransmogSetType {
    Armor,
    Class,
    Covenant,
}
